// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3n2Uf","right":"styles_right__2okcW"};